module.exports = require("web3-core");